const DataPinnedItemIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={16} height={16} viewBox='0 0 16 16' fill='none'>
      <path d='M8 11.332V14.6654V11.332Z' fill='#402080' />
      <path
        d='M8 11.332V14.6654'
        stroke='#402080'
        strokeWidth={1.33333}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.0026 7.17203C6.00247 7.42009 5.93315 7.66319 5.80242 7.874C5.67169 8.08481 5.48475 8.25498 5.2626 8.36537L4.07594 8.96536C3.8538 9.07575 3.66685 9.24592 3.53612 9.45673C3.4054 9.66754 3.33607 9.91064 3.33594 10.1587V10.6654C3.33594 10.8422 3.40618 11.0117 3.5312 11.1368C3.65622 11.2618 3.82579 11.332 4.0026 11.332H12.0026C12.1794 11.332 12.349 11.2618 12.474 11.1368C12.599 11.0117 12.6693 10.8422 12.6693 10.6654V10.1587C12.6691 9.91064 12.5998 9.66754 12.4691 9.45673C12.3384 9.24592 12.1514 9.07575 11.9293 8.96536L10.7426 8.36537C10.5205 8.25498 10.3335 8.08481 10.2028 7.874C10.0721 7.66319 10.0027 7.42009 10.0026 7.17203V4.66536C10.0026 4.48855 10.0728 4.31898 10.1979 4.19396C10.3229 4.06894 10.4925 3.9987 10.6693 3.9987C11.0229 3.9987 11.362 3.85822 11.6121 3.60817C11.8621 3.35813 12.0026 3.01899 12.0026 2.66536C12.0026 2.31174 11.8621 1.9726 11.6121 1.72256C11.362 1.47251 11.0229 1.33203 10.6693 1.33203H5.33594C4.98232 1.33203 4.64318 1.47251 4.39313 1.72256C4.14308 1.9726 4.0026 2.31174 4.0026 2.66536C4.0026 3.01899 4.14308 3.35813 4.39313 3.60817C4.64318 3.85822 4.98232 3.9987 5.33594 3.9987C5.51275 3.9987 5.68232 4.06894 5.80734 4.19396C5.93237 4.31898 6.0026 4.48855 6.0026 4.66536V7.17203Z'
        fill='#402080'
        stroke='#402080'
        strokeWidth={1.33333}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default DataPinnedItemIcon
